
























import {Component, Prop, Vue} from 'vue-property-decorator';
import CloseButton from '@/components/headers/CloseButton.vue';

@Component({
	components: {
		CloseButton,
	}
})
export default class ModalHeader extends Vue {
	@Prop({default: 'center-align'})
	alignmentClass!: string;

	@Prop({required: true})
	title!: string;

	@Prop({default: ''})
	subtitle!: string;

	@Prop({default: false})
	showClose!: boolean;

	@Prop({default: false})
	showBack!: boolean;
}
